

import {
  BellIcon,
  BookIcon,
  DbIcon,
  FolderIcon,
  GroupIcon,
  MapIcon,
  MultiplePagesEmptyIcon,
  PinAltIcon,
  ProfileCircleIcon,
  ReportColumnsIcon,
  StatsReportIcon,
  SuggestionIcon,
  NewHousingHouseIcon,
} from "@/components/icons-lib";

import { ENavigationKeys } from "./enums/navigation-keys.enum";
import { type INavigationCreate } from "./interface";


export const config: INavigationCreate = {
  basepath: "",
  defaultRoles: [],
  children: [
    {
      key: ENavigationKeys.SignIn,
      name: "Sign-in",
      href: "/auth/sign-in",
    },
    {
      key: ENavigationKeys.SignUp,
      name: "Sign-up",
      href: "/auth/sign-up",
    },
    {
      key: ENavigationKeys.ForgotPassword,
      name: "Reset password",
      href: "/auth/reset-password",
    },
    {
      key: ENavigationKeys.Panel,
      name: "Panel",
      href: "/panel",
      children: [
        {
          key: ENavigationKeys.Dashboard,
          name: "Dashboard",
          href: "/panel/dashboard",
          meta: { icon: ReportColumnsIcon },
        },
        {
          key: ENavigationKeys.Map,
          name: "Map Workspace",
          href: "/panel/map",
          meta: { icon: MapIcon },
        },
        {
          key: ENavigationKeys.MyDistrict,
          name: "My District",
          href: "/panel/my-district",
          meta: { icon: PinAltIcon },
        },
        {
          key: ENavigationKeys.NewHousing,
          name: "New Housing",
          href: "/panel/new-housing",
          meta: { icon: NewHousingHouseIcon },
        },
        {
          key: ENavigationKeys.Reports,
          name: "Reports",
          href: "/panel/reports",
          meta: { icon: StatsReportIcon },
        },
        {
          key: ENavigationKeys.ReportsAttendanceBoundaryPreview,
          name: "Review zones",
          href: "/panel/reports/preview-map",
        },
        {
          key: ENavigationKeys.Documents,
          name: "Documents",
          href: "/panel/documents",
          meta: { icon: MultiplePagesEmptyIcon },
        },
        {
          key: ENavigationKeys.Drive,
          name: "Files",
          href: "/panel/drive",
          meta: { icon: FolderIcon },
        },
        {
          key: ENavigationKeys.Data,
          name: "Data",
          href: "/panel/data",
          meta: { icon: DbIcon },
          // Canonical AI chat deep-links for missing-data live in API
          // apps/api/.../dataset-enter-targets.ts (leaf /panel/data/* paths; hub ?open= for modals).
          children: [
            {
              key: ENavigationKeys.DataSchoolList,
              name: "Upload School List Data",
              href: "/panel/data/school-list",
            },
            {
              key: ENavigationKeys.DataCapacityData,
              name: "Upload Capacity Data",
              href: "/panel/data/capacity-data",
            },
            {
              key: ENavigationKeys.DataMonthlyStudentData,
              name: "Upload Monthly Student Data",
              href: "/panel/data/monthly-student-data",
            },
            {
              key: ENavigationKeys.DataFallSnapshot,
              name: "Upload Fall Snapshot Data",
              href: "/panel/data/fall-snapshot",
            },
            {
              key: ENavigationKeys.DataAttendanceZones,
              name: "Upload Attendance Zones",
              href: "/panel/data/attendance-zones",
              meta: { icon: DbIcon },
            },
            {
              key: ENavigationKeys.DataDistrictBoundary,
              name: "Upload District Boundary",
              href: "/panel/data/district-boundary",
            },
            {
              key: ENavigationKeys.DataDistrictBoundaryPreview,
              name: "Review district boundary",
              href: "/panel/data/district-boundary/preview",
            },
            {
              key: ENavigationKeys.DataCustomLayers,
              name: "Upload Custom Layers",
              href: "/panel/data/custom-layers",
            },
            {
              key: ENavigationKeys.DataCustomLayersPreview,
              name: "Review custom layers",
              href: "/panel/data/custom-layers/preview",
            },
            {
              key: ENavigationKeys.DataNewHousing,
              name: "Upload New Housing Data",
              href: "/panel/data/new-housing",
            },
          ],
        },
        {
          key: ENavigationKeys.AiAssistant,
          name: "AI Assistant",
          href: "/panel/ai-assistant",
          meta: { icon: SuggestionIcon },
          children: [
            {
              key: ENavigationKeys.AiAssistantChat,
              name: "AI Assistant Chat",
              href: "/panel/ai-assistant/{chatId}",
            },
          ],
        },
        {
          key: ENavigationKeys.Users,
          name: "User Management",
          href: "/panel/users",
          meta: { icon: GroupIcon },
        },
        {
          key: ENavigationKeys.AccountSettings,
          name: "Account Settings",
          href: "/panel/account",
          meta: { icon: ProfileCircleIcon },
        },
        {
          key: ENavigationKeys.AiGlossary,
          name: "AI Glossary",
          href: "/panel/ai-glossary",
          meta: { icon: BookIcon },
        },
      ],
    },
    {
      key: ENavigationKeys.AdminPanel,
      name: "Admin Panel",
      href: "/admin/panel",
      children: [
        {
          key: ENavigationKeys.AdminDashboard,
          name: "Dashboard",
          href: "/admin/panel/dashboard",
          meta: { icon: ReportColumnsIcon },
        },
        {
          key: ENavigationKeys.DistrictsMap,
          name: "Districts Map",
          href: "/admin/panel/districts-map",
          meta: { icon: MapIcon },
        },
        {
          key: ENavigationKeys.AdminData,
          name: "Data",
          href: "/admin/panel/data",
          meta: { icon: DbIcon },
        },
        {
          key: ENavigationKeys.AdminUserManagement,
          name: "User Management",
          href: "/admin/panel/users",
          meta: { icon: GroupIcon },
        },
        {
          key: ENavigationKeys.AdminAiGlossary,
          name: "AI Glossary",
          href: "/admin/panel/ai-glossary",
          meta: { icon: BookIcon },
        },
        {
          key: ENavigationKeys.AdminChatAlerts,
          name: "Chat Alerts",
          href: "/admin/panel/chat-alerts",
          meta: { icon: BellIcon },
        },
      ],
    },
  ],
};
